import { lazy } from "react";

const RestreamCreateModal = lazy(() =>
    import("@kaltura/mediaspace-features-restream").then((m) => ({ default: m.RestreamCreateModal }))
);

const MediaEditTab = lazy(() =>
    import("@kaltura/mediaspace-features-restream").then((m) => ({ default: m.MediaEditTab }))
);

export { RestreamCreateModal, MediaEditTab };
